<ng-container style="display: none">
    <gird-column-template></gird-column-template>
    <combo-item-template></combo-item-template>
    <div kendoWindowContainer></div>
    <div kendoDialogContainer></div>
</ng-container>
<router-outlet></router-outlet>